// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilitySpendDown {
    static getAttributeTypeMap() {
        return MedicalEligibilitySpendDown.attributeTypeMap;
    }
}
MedicalEligibilitySpendDown.discriminator = undefined;
MedicalEligibilitySpendDown.additionalProperties = false;
MedicalEligibilitySpendDown.attributeTypeMap = [
    {
        "name": "exists",
        "baseName": "exists",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalEligibilitySpendDown.js.map